import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { BREAKPOINT_SMALL_LARGE, translateBackendErrorCode } from "@jti/fe-common";
import { CasProfileApi } from "@jti/rest-api";
import { useViewport } from "../../hooks/useViewport";
import AppleWallet from "../../images/add_to_apple_wallet.svg";
import GooglePay from "../../images/add_to_google_pay.svg";
import { useConfig } from "../../providers/useConfig";
import { useTranslations } from "../../providers/useTranslations";
import { createWalletUrl } from "../../utils/createWalletUrl";
import { getPhonePlatform } from "../../utils/getPhonePlatform";
import styles from "./AddToWallet.module.scss";
export const AddToWallet = () => {
    const [platform, setPlatform] = useState(null);
    const [loading, setLoading] = useState(false);
    const { ANDROID_IMG, APPLE_IMG, CAS_URL } = useConfig();
    const { width } = useViewport();
    const { __ } = useTranslations();
    const isMobile = width <= BREAKPOINT_SMALL_LARGE;
    const isApple = platform === "apple";
    const [WalletSvgImage, externalImage] = isApple ? [AppleWallet, APPLE_IMG] : [GooglePay, ANDROID_IMG];
    const label = isApple ? __("libs.ui.add_to_wallet.apple.label") : __("libs.ui.add_to_wallet.google.label");
    const isValidExternalImage = externalImage?.trim();
    useEffect(() => {
        setPlatform(getPhonePlatform());
    }, []);
    const requestWalletUrl = async () => {
        setLoading(true);
        try {
            const { data } = await CasProfileApi.init().requestWalletUrl(platform);
            if (data?.pass_url) {
                const finalUrl = isApple ? createWalletUrl(CAS_URL, data.pass_url).toString() : data.pass_url;
                window.location.href = finalUrl;
            }
            else {
                toast.error(__("libs.ui.add_to_wallet.error_message"));
            }
        }
        catch (error) {
            toast.error(translateBackendErrorCode(error?.error_code, __("libs.ui.add_to_wallet.error_message")));
        }
        finally {
            setLoading(false);
        }
    };
    if (!isMobile || !platform)
        return null;
    return (_jsx("button", { type: "button", onClick: requestWalletUrl, disabled: loading, "aria-disabled": loading, "aria-label": label, className: styles.walletButton, "data-testid": "addToWallet", children: isValidExternalImage ? (_jsx("img", { src: externalImage, alt: label, className: styles.walletImage })) : (_jsx(WalletSvgImage, {})) }));
};
//# sourceMappingURL=AddToWallet.js.map